/* KLIP — comportements partagés des encarts.
   1) compteurs animés (count-up) au scroll ;
   2) autoplay des vidéos UGC quand elles sont visibles.
   Aucune dépendance. Robuste aux re-rendus de l'éditeur de thème. */
(function(){
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  function formate(v, format){
    if(format === 'millier'){
      if(v >= 1000){ return Math.round(v/1000) + ' 000'; }
      return String(Math.round(v));
    }
    return String(Math.round(v));
  }

  function anime(el){
    if(el.dataset.kDone) return;
    el.dataset.kDone = '1';
    var cible = parseFloat(el.dataset.cible || '0');
    var format = el.dataset.format || 'entier';
    if(reduce){ el.textContent = formate(cible, format); return; }
    var duree = 1600, debut = null;
    function pas(ts){
      if(!debut) debut = ts;
      var p = Math.min((ts - debut)/duree, 1);
      var ease = 1 - Math.pow(1 - p, 3);
      el.textContent = formate(cible * ease, format);
      if(p < 1) requestAnimationFrame(pas);
    }
    requestAnimationFrame(pas);
  }

  function initCompteurs(root){
    var els = (root || document).querySelectorAll('.k-compte');
    if(!('IntersectionObserver' in window)){ els.forEach(anime); return; }
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ anime(e.target); obs.unobserve(e.target); } });
    }, {threshold:.4});
    els.forEach(function(el){ obs.observe(el); });
  }

  function initVideos(root){
    var vids = (root || document).querySelectorAll('video[data-k-autoplay]');
    if(!('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        var v = e.target;
        if(e.isIntersecting){ v.play && v.play().catch(function(){}); }
        else { v.pause && v.pause(); }
      });
    }, {threshold:.35});
    vids.forEach(function(v){ v.muted = true; obs.observe(v); });
  }

  function initAll(root){ initCompteurs(root); initVideos(root); }

  if(document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function(){ initAll(); });

  /* Éditeur de thème Shopify : re-initialiser à chaque (dé)chargement de section */
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();
